module.exports = __webpack_public_path__ + "static/media/facebook-icon.ff33fe0e.svg";